// extracted by mini-css-extract-plugin
export default {"root":"Search_root__zA-ff","svgClear":"Search_svgClear__5Dbvg"};